/**
 * Функция нужна для получения 'Value' query параметра
 * @param name - передаем названия query параметра
 */
export function getQueryParamValue(name: string): string | null {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(name);
}
